import { render, staticRenderFns } from "./DoctorSearch.vue?vue&type=template&id=3a48c130&scoped=true&"
import script from "./DoctorSearch.vue?vue&type=script&lang=js&"
export * from "./DoctorSearch.vue?vue&type=script&lang=js&"
import style0 from "./DoctorSearch.vue?vue&type=style&index=0&id=3a48c130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a48c130",
  null
  
)

export default component.exports